module.exports = __webpack_public_path__ + "img/datacenter17.5f06bb79.png";